"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccDoctemplateXApi = void 0;
const icc_api_1 = require("../icc-api");
const lodash_1 = require("lodash");
const binary_utils_1 = require("./utils/binary-utils");
const XHR_1 = require("../icc-api/api/XHR");
// noinspection JSUnusedGlobalSymbols
class IccDoctemplateXApi extends icc_api_1.IccDoctemplateApi {
    constructor(host, headers, crypto, fetchImpl = typeof window !== 'undefined'
        ? window.fetch
        : typeof self !== 'undefined'
            ? self.fetch
            : fetch) {
        super(host, headers, fetchImpl);
        this.crypto = crypto;
        this.fetchImpl = fetchImpl;
    }
    newInstance(user, template, c) {
        return new Promise((resolve, reject) => {
            const documentTemplate = lodash_1.extend({
                id: this.crypto.randomUuid(),
                _type: 'org.taktik.icure.entities.DocumentTemplate',
                owner: user.id,
                created: new Date().getTime(),
                modified: new Date().getTime(),
                guid: this.crypto.randomUuid(),
                group: null,
                specialty: null,
                attachment: binary_utils_1.string2ua(template),
                mainUti: 'public.plain-text',
            }, c || {});
            if (documentTemplate.group && documentTemplate.group.guid == null) {
                documentTemplate.group.guid = this.crypto.randomUuid();
            }
            //sauver l doctemplate vide
            if (template) {
                //save attachement
            }
            return resolve(documentTemplate);
        });
    }
    // noinspection JSUnusedLocalSymbols
    findAllByOwnerId(ownerId) {
        return new Promise(function (resolve, reject) {
            reject(console.log('findByHCPartyPatientSecretFKeys not implemented in document API!'));
        });
    }
    // noinspection JSUnusedGlobalSymbols
    getAttachmentUrl(documentId, attachmentId) {
        return (this.host + '/doctemplate/{documentId}/attachment/{attachmentId}'.replace('{documentId}', documentId).replace('{attachmentId}', attachmentId));
    }
    getAttachmentText(documentTemplateId, attachmentId) {
        const _body = null;
        const _url = this.host +
            '/doctemplate/{documentTemplateId}/attachmentText/{attachmentId}'
                .replace('{documentTemplateId}', documentTemplateId + '')
                .replace('{attachmentId}', attachmentId + '') +
            '?ts=' +
            new Date().getTime();
        return XHR_1.XHR.sendCommand('GET', _url, this.headers, _body, this.fetchImpl)
            .then((doc) => {
            if (doc.contentType.startsWith('application/octet-stream')) {
                const enc = new TextDecoder('utf-8');
                const arr = new Uint8Array(doc.body);
                return enc.decode(arr);
            }
            else if (doc.contentType.startsWith('text/plain') || doc.contentType.startsWith('text/html') || doc.contentType.startsWith('text/xml')) {
                return doc.body;
            }
            else {
                return false;
            }
        })
            .catch((err) => this.handleError(err));
    }
}
exports.IccDoctemplateXApi = IccDoctemplateXApi;
//# sourceMappingURL=icc-doctemplate-x-api.js.map